import { Fade } from '@mui/material';
import { validateEnum, withDefault } from '@vy/utils';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { useTabParam } from '../../../hooks/use-tab-param';
import type { PageTab } from '../../../utils/types/page-tab';
import { ContractsTabContent } from './plans-page-components/ContractsTabContent/ContractsTabContent';
import { PlansTabContent } from './plans-page-components/PlansTabContent/PlansTabContent';
import type { PlansPageTabs } from './plans-page-types/plans-page-tabs';
import { PLANS_PAGE_TABS } from './plans-page-types/plans-page-tabs';

const plansPageTabs: Record<PlansPageTabs, PageTab<PlansPageTabs>> = {
  [PLANS_PAGE_TABS.contracts]: {
    id: 0,
    render: <ContractsTabContent />,
    label: 'Customer contracts',
    paramName: PLANS_PAGE_TABS.contracts,
  },
  [PLANS_PAGE_TABS.plans]: {
    id: 1,
    render: <PlansTabContent />,
    label: 'Plan templates',
    paramName: PLANS_PAGE_TABS.plans,
  },
};

const PlansPage: React.FC = () => {
  const [tab, setTab] = useTabParam<PlansPageTabs>(PLANS_PAGE_TABS.contracts, deserializePlansPageTabParam);
  const currentTab = withDefault(tab, PLANS_PAGE_TABS.contracts);

  return (
    <>
      <Helmet>
        <title>{currentTab === PLANS_PAGE_TABS.contracts ? 'Contracts' : 'Plans'}</title>
      </Helmet>
      <VyLayout
        currentTab={withDefault(currentTab, PLANS_PAGE_TABS.contracts)}
        tabs={[
          {
            label: 'Customer contracts',
            value: PLANS_PAGE_TABS.contracts,
            onClick: () => setTab(PLANS_PAGE_TABS.contracts),
          },
          {
            label: 'Plan templates',
            value: PLANS_PAGE_TABS.plans,
            onClick: () => setTab(PLANS_PAGE_TABS.plans),
          },
        ]}
      >
        {Object.entries(plansPageTabs).map(([plansPageTab, { id, render }]) => (
          <Fade key={id} hidden={currentTab !== plansPageTab} in={currentTab === plansPageTab}>
            <div className="h-full w-full">{currentTab === plansPageTab && render}</div>
          </Fade>
        ))}
      </VyLayout>
    </>
  );
};

const PlansPageWithSuspenseBoundary = withSuspenseBoundary(withGlobalSearchParams(PlansPage));
export { PlansPageWithSuspenseBoundary as PlansPage };

function deserializePlansPageTabParam(tab: string): PlansPageTabs | null {
  validateEnum(tab, PLANS_PAGE_TABS);

  return tab;
}
